import {
  imgproxySettings,
  mobileImgproxySettings,
  lifestyleLensTechRemovalPattern,
  stripMatteOrInfinitePrefix,
} from './shared.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Fclear: {
      pathTemplate: 'gs://sg360/250725/tempests/Tf_Clear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tf_Clear_{nnn}.png',
      override: { earsocks: 'Rgrey' },
    },
    clear: {
      pathTemplate: 'gs://sg360/250725/tempests/Tf_Clear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tf_Clear_{nnn}.png',
      override: { earsocks: 'Rgrey' },
    },
    grey: {
      pathTemplate: 'gs://sg360/250725/tempests/Tf_Grey_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tf_Grey_{nnn}.png',
      override: { earsocks: 'Rgrey' },
    },
    black: {
      pathTemplate: 'gs://sg360/250725/tempests/Tf_Black_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tf_Black_{nnn}.png',
      override: { earsocks: 'Rblack' },
    },
    navy: {
      pathTemplate: 'gs://sg360/250725/tempests/Tf_Navy_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tf_Navy_{nnn}.png',
      override: { earsocks: 'Rnavy' },
    },
    carbon: {
      pathTemplate: 'gs://sg360/250725/tempests/Tf_Carbon_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tf_Carbon_{nnn}.png',
      override: { earsocks: 'Rblack' },
    },
    stone: {
      pathTemplate: 'gs://sg360/250725/tempests/Tf_Stone_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tf_Stone_{nnn}.png',
      override: { earsocks: 'Rstone' },
    },
    white: {
      pathTemplate: 'gs://sg360/250725/tempests/Tf_White_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tf_White_{nnn}.png',
      override: { earsocks: 'Rwhite' },
    },
  },
}

export const icons = {
  id: 'icons',
  name: 'Icons',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Bblack: {
      pathTemplate: 'gs://sg360/250725/tempests/Ti_Black_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Ti_Black_{nnn}.png',
    },
    Bblue: {
      pathTemplate: 'gs://sg360/250725/tempests/Ti_Blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Ti_Blue_{nnn}.png',
    },
    Bgold: {
      pathTemplate: 'gs://sg360/250725/tempests/Ti_Gold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Ti_Gold_{nnn}.png',
    },
    Bgreen: {
      pathTemplate: 'gs://sg360/250725/tempests/Ti_Green_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Ti_Green_{nnn}.png',
    },
    Bpurple: {
      pathTemplate: 'gs://sg360/250725/tempests/Ti_Purple_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Ti_Purple_{nnn}.png',
    },
    Bred: {
      pathTemplate: 'gs://sg360/250725/tempests/Ti_Red_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Ti_Red_{nnn}.png',
    },
    Bsilver: {
      pathTemplate: 'gs://sg360/250725/tempests/Ti_Silver_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Ti_Silver_{nnn}.png',
    },
    Bwhite: {
      pathTemplate: 'gs://sg360/250725/tempests/Ti_White_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Ti_White_{nnn}.png',
    },
    Bgunmetal: {
      pathTemplate: 'gs://sg360/260811/Ti_gunmetal_{nnn}.png',
      staticPathTemplate: 'gs://sg360/260811/Ti_gunmetal_{nnn}.png',
    },
  },
}

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    blue: {
      pathTemplate: 'gs://sg360/250725/tempests/Tle_Blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tle_Blue_{nnn}.png',
    },
    fire: {
      pathTemplate: 'gs://sg360/250725/tempests/Tle_Fire_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tle_Fire_{nnn}.png',
    },
    gold: {
      pathTemplate: 'gs://sg360/250725/tempests/Tle_Gold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tle_Gold_{nnn}.png',
    },
    green: {
      pathTemplate: 'gs://sg360/250725/tempests/Tle_Green_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tle_Green_{nnn}.png',
    },
    purple: {
      pathTemplate: 'gs://sg360/250725/tempests/Tle_Purple_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tle_Purple_{nnn}.png',
    },
    red: {
      pathTemplate: 'gs://sg360/220601/SG09/SG09le/SG09le_red_{nnn}.png',
      staticPathTemplate: 'gs://sg360/230426/Tempests/SG09le_red_{nnn}.png',
    },
    silverblue: {
      pathTemplate: 'gs://sg360/250725/tempests/Tle_Silver_Blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tle_Silver_Blue_{nnn}.png',
    },
    smoke: {
      pathTemplate: 'gs://sg360/250725/tempests/Tle_Smoke_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tle_Smoke_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/270624/Tempests/rgle/rgle_clear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/270624/Tempests/rgle/rgle_clear_{nnn}.png',
    },
    water: {
      pathTemplate: 'gs://sg360/250725/tempests/Tle_Blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tle_Blue_{nnn}.png',
    },
  },
}

export const earsocks = {
  id: 'earsocks',
  name: 'Earsocks',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Rblack: {
      pathTemplate: 'gs://sg360/250725/tempests/Tes_Black_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tes_Black_{nnn}.png',
    },
    Rgrey: {
      pathTemplate: 'gs://sg360/250725/tempests/Tes_Grey_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tes_Grey_{nnn}.png',
    },
    Rnavy: {
      pathTemplate: 'gs://sg360/250725/tempests/Tes_Navy_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tes_Navy_{nnn}.png',
    },
    Rstone: {
      pathTemplate: 'gs://sg360/250725/tempests/Tes_Stone_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tes_Stone_{nnn}.png',
    },
    Rwhite: {
      pathTemplate: 'gs://sg360/250725/tempests/Tes_White_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tempests/Tes_White_{nnn}.png',
    },
  },
}

export const engraving = {
  id: 'engraving',
  name: 'Engraving',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    eN: {
      pathTemplate: 'gs://sg360/220601/SG09/SG09lg/SG09lg_N_{nnn}.png',
    },
    eP: {
      pathTemplate: 'gs://sg360/220601/SG09/SG09lg/SG09lg_P_{nnn}.png',
    },
    e8: {
      pathTemplate: 'gs://sg360/220601/SG09/SG09lg/SG09lg_8_{nnn}.png',
    },
    e8P: {
      pathTemplate: 'gs://sg360/220601/SG09/SG09lg/SG09lg_8P_{nnn}.png',
    },
    e8W: {
      pathTemplate: 'gs://sg360/130625/Tempests/SG09lg/SG09lg_8W_v2_{nnn}.png',
    },
    e8PW: {
      pathTemplate: 'gs://sg360/130625/Tempests/SG09lg/SG09lg_8PW_v2_{nnn}.png',
    },
    none: {
      disabled: true,
    },
  },
}

export const background = {
  id: 'background',
  name: 'Background',
  imgproxySettings: ['insecure', 'resize:fill:1400', 'plain'],
  mobileImgproxySettings: ['insecure', 'resize:fill:800', 'plain'],
  isBackground: true,
  options: {
    default: {
      pathTemplate: 'gs://sg360/250725/tempests/T_Shadow_{nnn}.png',
    },
  },
}

export function resolveOptions(customisedProduct) {
  const engraving =
    {
      '4ko': 'eN',
      '4kop': 'eP',
      '8ko': 'e8',
      '8kop': 'e8P',
      '8kowater': 'e8W',
      '8kopwater': 'e8PW',
    }[customisedProduct.lensTech] || 'none'

  const choices = {
    frame: stripMatteOrInfinitePrefix(customisedProduct.frameChoice?.skuWithoutPrefix),
    lens: customisedProduct.lensChoice.skuWithoutLensTech.split('_')?.slice(1)?.join('_'),
    icons: customisedProduct.iconChoice?.sku?.split('_')?.slice(1)?.join('_'),
    engraving,
  }

  // Determine earsocks from override set in frame definition
  const frameOverride = frame.options[choices.frame]?.override
  choices.earsocks = frameOverride?.earsocks || null

  return choices
}

export function resolveOptionsFromSKU(sku) {
  const frameSKUPrefixes = ['tf']
  const lensSKUPrefixes = ['tle', 'rgle']
  const iconSKUPrefixes = ['ti', 'i']

  const getEngraving = (choice) => {
    const engravings = [
      [/^N/g, 'eN'],
      [/^P/g, 'eP'],
      [/^8(?!P|IR)/g, 'e8'],
      [/^8P/g, 'e8P'],
    ]
    return engravings.find(([pattern, _option]) => choice.match(pattern))?.[1] || 'none'
  }

  const parts = sku.split('-').slice(1)
  const choices = Object.fromEntries(
    parts
      .map((part) => {
        const [skuPrefix, choice] = part.split('_')
        if (frameSKUPrefixes.includes(skuPrefix)) return [['frame', stripMatteOrInfinitePrefix(choice)]]
        if (lensSKUPrefixes.includes(skuPrefix))
          return [
            ['lens', choice.replace(lifestyleLensTechRemovalPattern, '')],
            ['engraving', getEngraving(choice)],
            ['reflections', 'r5pc'],
          ]
        if (iconSKUPrefixes.includes(skuPrefix)) return [['icons', choice]]

        return null
      })
      .filter((choice) => choice)
      .flat()
  )

  // Determine earsocks from override set in frame definition
  const frameOverride = frame.options[choices.frame]?.override
  choices.earsocks = frameOverride?.earsocks || null

  return choices
}

export default {
  layers: [background, frame, earsocks, icons, lenses, engraving],
  resolveOptions,
  resolveOptionsFromSKU,
}
